import { render } from "./StSisbiSelect.vue?vue&type=template&id=0f9a7882"
import script from "./StSisbiSelect.vue?vue&type=script&lang=js"
export * from "./StSisbiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__